import React from 'react';
import { withRouter } from 'react-router-dom';

import API, {handleError} from 'utils/xhr';

import Track from 'utils/tracker';
import {InstructionsPara} from 'component/reuse/instruction';


class SiteAddForm extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      site_name: '',
    }
  }

  onChange(e){
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  addSite() {
    const url = '/sites';

    if (this.state.site_name === ''){
      alert("Site cannot be empty!")
      return;
    }

    var data = {
      site_name: this.state.site_name,
    }

    API.post(url, data).then(response => {
      this.setState({site_name: '',});
      const site_xid = response.data.data.xid;
      Track.site("Created", site_xid);
      window.location.reload();  // TODO : fix the window reload

    }, (error) => {
      Track.site("Creation failed");
      handleError(error);
    });
  }

  render (){
    const {site_name} = this.state;

    return (
      <div className="p-2 col-sm-12 col-md-12 rounded">
        <h3 className="col-sm-12 family-h3">Add a new website:</h3>
        <InstructionsPara classAdd="col-sm-12" showXID={this.props.showXID}/>
        <div className="col-sm-12 col-md-6">
          <div className="form-group">
              <input
                type="text"
                className="form-control"
                name="site_name"
                onChange={this.onChange.bind(this)}
                value={site_name}
                placeholder="mysaas.com | blog.mysaas.com | mysite.com onboarding | mysite.com support etc ..."/>
          </div>
          <div className="form-group">
            <button
              onClick={this.addSite.bind(this)}
              className="btn btn-success btn-lg">
              <i className="fa fa-plus"></i> Add website
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(SiteAddForm);
